module.exports = __webpack_public_path__ + "img/no_data.2e5e7152.png";